import { Form, FormInstance, Input, Select } from "antd";

import Typography from "../../Typography/Typography";
import DocumentModalFileUploader from "./DocumentModalFileUploader";
import { usePermissions } from "@/common/contexts/Permissions.context";
import DocumentCompanyByName from "./DocumentCompanyByName";
import { DocumentFormFields } from "@/common/types/forms/DocumentFormFields.type";

export default function DocumentOtherStep({
  form,
  selectedCompanyType,
}: {
  form: FormInstance<DocumentFormFields>;
  selectedCompanyType: string;
}) {
  const { company } = usePermissions();
  return (
    <>
      <div className="flex flex-col gap-5">
        <div className="flex gap-4">
          <div>
            <Typography
              mb={4}
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              fontSize={16}
            >
              Document Name
              <Typography
                type="span"
                fontFamily="font-kanit"
                fontWeight="font-light"
                textColor="error"
              >
                *
              </Typography>
            </Typography>

            <Form.Item
              name="documentName"
              rules={[
                { required: true, message: "Please select document name" },
              ]}
            >
              <Input
                placeholder="Document Name"
                className="min-w-[230px] bg-gray-border border-none hover:bg-primaryDim h-10 rounded-lg"
              />
            </Form.Item>
          </div>
          <div>
            <Typography
              mb={4}
              type="p"
              fontFamily="font-kanit"
              fontWeight="font-light"
              fontSize={16}
            >
              Status
              <Typography
                type="span"
                fontFamily="font-kanit"
                fontWeight="font-light"
                textColor="error"
              >
                *
              </Typography>
            </Typography>

            <Form.Item
              name="status"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Select
                placeholder="Select"
                className="min-w-[230px] bg-gray-border hover:bg-primaryDim h-10 rounded-lg "
              >
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
                <Select.Option value="updated">Updated</Select.Option>
              </Select>
            </Form.Item>
          </div>
        </div>

        {company.companyType === "airx" && selectedCompanyType !== "airx" && (
          <DocumentCompanyByName
            form={form}
            selectedCompanyType={selectedCompanyType}
          />
        )}

        <DocumentModalFileUploader />
      </div>
    </>
  );
}
